import {csiHost, executeGetAssets, executeGetAsset  } from '../simbix/executer'

//Загрузка содержимого каталога моделей, содержащийх пакеты информацинного обмена  (из модуля adms)
//Загружается список asset по условию и дополнительному условию, что родительским элементом должен быть NodId 
//Заданный в repository
export const PackInfoExchageActions = {
    LOAD_LIST_STARTED: () => ({
        type: PackInfoExchageActions.LOAD_LIST_STARTED,
    }),
    LOAD_LIST_OK: members => ({
        type: PackInfoExchageActions.LOAD_LIST_OK,
        members,
    }),
    LOAD_LIST_ERROR: () => ({
        type: PackInfoExchageActions.LOAD_ERROR,
    }),

    //Загрузка списка элементов
    // repository - указывает каталог (NodId) в котором записаны элементы
    // offset, limit - начало и колчество записей для загрузки ( на данном этапе игнорируется) 
    // filter - дополнительные условия отбора (используется логическое И)
    loadMembers: (repository, offset, limit, filter) => dispatch => {
        dispatch(PackInfoExchageActions.LOAD_LIST_STARTED());
        const condition = 'ParId='+repository + ((filter)? " and "+filter:"");
        return executeGetAssets({host:csiHost, module:"adms", condition, type: "adms_asset"}) 
            .then(response => { 
                //console.log("loadMembers", response);
                const members = (response.assets)? response.assets.data: [];
                const tags = (response.tags)? response.tags.data: [];
                dispatch(PackInfoExchageActions.LOAD_LIST_OK({members, offset, limit, repository, tags}));
                return response;
            })
            .catch(e => { 
                console.error(new Error("cannot load descriptions module adms",e)); 
                dispatch(PackInfoExchageActions.LOAD_LIST_ERROR());
                return Promise.reject(e);
            });
    },

    LOAD_ITEM_STARTED: () => ({
        type: PackInfoExchageActions.LOAD_ITEM_STARTED,
    }),
    LOAD_ITEM_OK: selected => ({
        type: PackInfoExchageActions.LOAD_ITEM_OK,
        selected,
    }),
    LOAD_ITEM_ERROR: () => ({
        type: PackInfoExchageActions.LOAD_ITEM_ERROR,
    }),

    //Загружает информацию по одному элементу каталога
    loadSelected: (NodId, repository)  => dispatch => {
        dispatch(PackInfoExchageActions.LOAD_ITEM_STARTED());
        return executeGetAsset({host:csiHost, module:"adms", id: NodId, type: "adms_asset"}) 
            .then(response => { 
                //console.log("executeGetAsset", response);
                dispatch(PackInfoExchageActions.LOAD_ITEM_OK({record: response.asset, id:NodId}));
                return response;
            })
            .catch(e => { 
                console.error(new Error("cannot load selected in module adms",e)); 
                dispatch(PackInfoExchageActions.LOAD_ITEM_ERROR());
                return Promise.reject(e);
            });
    },    

    CHANGE_CONDITIONS: conditions => ({
        type: PackInfoExchageActions.CHANGE_CONDITIONS,
        conditions,
    }),

    changeConditions: conditions => dispatch => {
        dispatch(PackInfoExchageActions.CHANGE_CONDITIONS(conditions));
        return Promise.resolve(conditions);
    },

}